import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';

export type PermanentDeleteConfirmModalProps =
  | {
      open: boolean;
      variant: 'bulkRecords';
      selectedCount: number;
      operationCount: number;
      onConfirm: () => void;
      onClose: () => void;
      isProcessing?: boolean;
    }
  | {
      open: boolean;
      variant: 'bulkFolders';
      selectedCount: number;
      onConfirm: () => void;
      onClose: () => void;
      isProcessing?: boolean;
    };

export default function PermanentDeleteConfirmModal(props: PermanentDeleteConfirmModalProps) {
  const isProcessing = props.isProcessing ?? false;

  const title =
    props.variant === 'bulkFolders'
      ? 'Permanently delete selected folders'
      : 'Permanently delete selected records';

  const body =
    props.variant === 'bulkFolders'
      ? props.selectedCount === 1
        ? `This removes the folder row(s) from the database and deletes matching cloud files where possible. This cannot be undone.`
        : `This removes ${props.selectedCount} folder trees from the database and deletes matching cloud files where possible. This cannot be undone.`
      : props.selectedCount === 1
        ? `This permanently deletes the underlying records for ${props.operationCount} recycle-bin group (bundled items are removed together). This cannot be undone.`
        : `This permanently deletes underlying records for ${props.operationCount} recycle-bin groups (${props.selectedCount} rows selected). Bundled items are removed together. This cannot be undone.`;

  return (
    <Dialog open={props.open} onClose={() => !isProcessing && props.onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{body}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} disabled={isProcessing}>
          Cancel
        </Button>
        <Button
          onClick={props.onConfirm}
          variant="contained"
          color="error"
          disabled={isProcessing}
          startIcon={isProcessing ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {isProcessing ? 'Deleting…' : 'Delete permanently'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
